import React from "react";
import { useTranslation } from "react-i18next";
import { PalType } from "../../types/Pal";

interface AddPalFormHeaderProps {
  palType: PalType | null;
  isEdit?: boolean;
}

const AddOrEditPalFormHeader: React.FC<AddPalFormHeaderProps> = ({
  palType,
  isEdit = false,
}) => {
  const { t } = useTranslation();

  if (palType === "LivePal") {
    return isEdit
      ? t("edit.liveVenue", "Modifica locale")
      : t("add.liveVenue", "Aggiungi un locale");
  } else {
    return isEdit
      ? t("edit.gearProvider", "Modifica fornitore")
      : t("add.gearProvider", "Aggiungi attrezzatura");
  }
};

export default AddOrEditPalFormHeader;
